<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Australia: Monarchy, Nature and Beyond</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#introduction">Introduction</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#our-monarchy-system">Our Monarchy System</a></li>
<li id="toc-li-5"><span href="#/Text/ch005#understanding-how-and-why-our-monarchy-system-works" title="Link target outside of Sample">Understanding How and Why Our Monarchy System Works</span></li>
<li id="toc-li-6"><span href="#/Text/ch006#the-credentials-of-the-monarchy" title="Link target outside of Sample">The Credentials of the Monarchy</span></li>
<li id="toc-li-7"><span href="#/Text/ch007#the-mystique-of-our-system-ownership" title="Link target outside of Sample">The Mystique of Our System-Ownership</span></li>
<li id="toc-li-8"><span href="#/Text/ch008#reserve-rights-empowering-the-people" title="Link target outside of Sample">Reserve Rights – Empowering the People</span></li>
<li id="toc-li-9"><span href="#/Text/ch009#a-brief-history" title="Link target outside of Sample">A Brief History</span></li>
<li id="toc-li-10"><span href="#/Text/ch010#conventions-the-peoples-emotional-capital" title="Link target outside of Sample">Conventions – The People’s Emotional Capital</span></li>
<li id="toc-li-11"><span href="#/Text/ch011#evolution-change-but-not-as-we-know-it" title="Link target outside of Sample">Evolution Change but Not as We Know It</span></li>
<li id="toc-li-12"><span href="#/Text/ch012#head-of-state" title="Link target outside of Sample">Head of State</span></li>
<li id="toc-li-13"><span href="#/Text/ch013#who-should-be-our-governor-general" title="Link target outside of Sample">Who Should Be Our Governor-General?</span></li>
<li id="toc-li-14"><span href="#/Text/ch014#importing-a-monarch-for-australia" title="Link target outside of Sample">Importing a Monarch for Australia</span></li>
<li id="toc-li-15"><span href="#/Text/ch015#succession" title="Link target outside of Sample">Succession</span></li>
<li id="toc-li-16"><span href="#/Text/ch016#paul-keating-guilty-by-association" title="Link target outside of Sample">Paul Keating Guilty by Association</span></li>
<li id="toc-li-17"><span href="#/Text/ch017#hereditary-conditioning" title="Link target outside of Sample">Hereditary Conditioning</span></li>
<li id="toc-li-18"><span href="#/Text/ch018#politicians" title="Link target outside of Sample">Politicians</span></li>
<li id="toc-li-19"><span href="#/Text/ch019#religion" title="Link target outside of Sample">Religion</span></li>
<li id="toc-li-20"><span href="#/Text/ch020#an-abstract-ideology" title="Link target outside of Sample">An Abstract Ideology</span></li>
<li id="toc-li-21"><span href="#/Text/ch021#comment-and-summary" title="Link target outside of Sample">Comment and Summary</span></li>
<li id="toc-li-22"><span href="#/Text/ch022#appointing-our-governor-general" title="Link target outside of Sample">Appointing Our Governor-General</span></li>
<li id="toc-li-23"><span href="#/Text/ch023#an-independent-speaker-for-parliament" title="Link target outside of Sample">An Independent Speaker for Parliament</span><ol class="toc"><li id="toc-li-24"><span href="#/Text/ch023#suggestion" title="Link target outside of Sample">Suggestion</span></li>
</ol></li>
<li id="toc-li-25"><span href="#/Text/ch024#appointing-judges" title="Link target outside of Sample">Appointing Judges</span></li>
<li id="toc-li-26"><span href="#/Text/ch025#the-dismissal" title="Link target outside of Sample">The Dismissal</span></li>
<li id="toc-li-27"><span href="#/Text/ch026#the-party-system-is-the-party-over" title="Link target outside of Sample">The Party System Is the Party Over?</span></li>
<li id="toc-li-28"><span href="#/Text/ch027#final-summary-and-comment" title="Link target outside of Sample">Final Summary and Comment</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?f51c71e6